import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress React error overlay for handled errors
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    // Suppress generic "Script error" which occurs for cross-origin issues
    if (event.message === 'Script error.' || 
        event.message?.includes('responseText') ||
        event.message?.includes('blob')) {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
  }, true);
  
  window.addEventListener('unhandledrejection', (event) => {
    // Suppress unhandled promise rejections that are actually handled
    if (event.reason?.message?.includes('responseText') ||
        event.reason?.message?.includes('blob') ||
        event.reason?.config?.responseType === 'blob') {
      event.preventDefault();
      return true;
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

